export function initFloatingHeader() {
	const floatingHeader = document.querySelector('[data-floating-header]');
	if (!(floatingHeader instanceof HTMLElement)) {
		return;
	}

	let lastScrollY = window.scrollY || 0;
	let heroBottom = getHeroBottom();

	const updateVisibility = () => {
		const currentY = window.scrollY || 0;
		const scrollingUp = currentY < lastScrollY - 2;
		const scrollingDown = currentY > lastScrollY + 2;
		const pastHero = isPastHero(currentY, heroBottom);
		const enoughOffset = currentY > 120;

		if (scrollingUp && pastHero && enoughOffset) {
			floatingHeader.classList.add('is-visible');
		}

		if (scrollingDown || !pastHero || !enoughOffset) {
			floatingHeader.classList.remove('is-visible');
		}

		lastScrollY = currentY;
	};

	const recalcHero = () => {
		heroBottom = getHeroBottom();
		updateVisibility();
	};

	window.addEventListener('scroll', updateVisibility, { passive: true });
	window.addEventListener('resize', recalcHero);
	window.addEventListener('load', recalcHero);

	recalcHero();
}

function getHeroBottom() {
	const hero = document.querySelector('.hero-block');
	if (!(hero instanceof HTMLElement)) {
		return 0;
	}

	const heroRect = hero.getBoundingClientRect();
	const scrollY = window.scrollY || 0;
	return heroRect.top + scrollY + heroRect.height;
}

function isPastHero(currentY, heroBottom) {
	if (heroBottom <= 0) {
		return true;
	}

	return currentY >= heroBottom;
}
